import { EntityTypes } from 'context/entityContext';

type AllowedRelatedEntitiesLookup = {
  [key: string]: (EntityTypes | 'version')[];
};

const allowedRelatedEntities: AllowedRelatedEntitiesLookup = {
  track: ['version', 'release', 'project', 'label'],
  release: ['version', 'track', 'project', 'label'],
  artist: ['track', 'release', 'project', 'label'],
  project: ['track', 'release'],
  label: ['track', 'release', 'project', 'artist'],
};

export default allowedRelatedEntities;
